
<template>
  <div class="product-newbox lesson-detail" v-if="details.length">
    <div class="p-detail-new nomargin"
      v-for="(item, index) in details"
      :class="{
        'expanded': !item.expanded
      }">
      <div class="p-title-box">
        <div class="title-box">
          <div class="title">{{item.title}}</div>
        </div>
        <div class="content-box">
          <div class="p-detail-content" v-for="modules in item.modules" >
            <div class="p-child-content" v-if="modules.type=='TEXT'">
              <div class="p-child-tit" v-html="formatHtml(modules.title)"></div>
            </div>

            <div class="p-text" v-if="(modules.type !== 'LINK') && modules.text" v-html="formatHtml(modules.text)">
              <!-- {{unescape(modules.text) | formatHtml}} -->
            </div>

            <div class="p-img" v-if="modules.image">
              <beast-image :src="modules.image.src" :width="modules.image.width" :height="modules.image.height" />
              <!-- <img :src="modules.image.src" :width="modules.image.width" :height="modules.image.height" /> -->
              <p class="p-img-desc">{{ modules.desc || '' }}</p>
            </div>

            <div class="p-variant" v-if="modules.type=='TABLE'" v-for="table in modules.table">
              <div class="p-variant-name">{{ table.tableRow[0] }}</div>
              <div class="p-variant-info" :class="{'fixed-variant': pageTypeImage}">
                <p v-html="unescape(table.tableRow[1])"></p>
              </div>
            </div>
            <div class="p-brand-wrap">
              <div class="p-brand-index" v-if="!pageTypeImage && modules.type=='LINK'">
                <a :href="modules.link | formatLink">{{modules.text}}</a><i></i>
              </div>
            </div>
          </div>
          <!-- <div class="split-line"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// test
import browser from '@beastshop/browser'
import beastImage from '@/components/image/'

import {
  getLink 
} from '@/components/app-menu/util'

const ENUM_TITLE = ['活动介绍', '讲师介绍', '退换货说明', '特别说明']

const isApp = browser.app()

export default {
  components: {
    beastImage
  },

  props:{
    data: {
      type: Object
    },
    pageTypeImage: Boolean
  },

  data () {
    return {
      details: [],
      isApp: isApp,
      isHide: false
    }
  },

  created () {
    const details = []
    this.data.details.forEach(detail => {
      if (~ENUM_TITLE.indexOf(detail.title)) {
        details.push(detail)
      }
    })

    this.details = details
  },

  methods:{
    unescape (str) {
      return str.replace(/\\n/gi, '<br/>')
    },

    formatHtml (text) {
      const reTag = /<(?:.|\s)*?>/g
      const styleAttr = /style="[^"]*"/g
      const remoeveTable = /<table[^>]*>[\s\S]*?<\/table>/g

      if (!text) return text

      let content = text.replace(styleAttr, "").replace( remoeveTable, "")

      // return content.replace(/[\n\r]/gi, '<br/>')
      return content.replace(/\r\n/gi, "<br/>");
    }
  },

  filters: {
    formatLink (link) {

      if (isApp) {
        return link
      }

      return getLink(link)
    }
  }
}
</script>



// WEBPACK FOOTER //
// product-detail.vue?530d7d72